import { gql } from "@apollo/client";

export const REVOKE_TOKEN_MUTATION = gql`
  mutation ($refreshToken: String!) {
    revokeToken(refreshToken: $refreshToken) {
      revoked
    }
  }
`;
export const LOGIN_MUTATION = gql`
  mutation ($username: String!, $password: String!) {
    tokenAuth(username: $username, password: $password) {
      token
      payload
      refreshToken
      refreshExpiresIn
    }
  }
`;
export const REQUEST_GET_SCHOOL_APPROVAL_MUTATION = gql`
  mutation ($dpoEmail: String) {
    requestGetSchoolApproval(dpoEmail: $dpoEmail) {
      success
      message
    }
  }
`;
export const LOGIN_WITH_SSO_MUTATION = gql`
  mutation ($provider: String!, $token: String!) {
    loginWithSso(provider: $provider, token: $token) {
      token
      payload
      refreshToken
      refreshExpiresIn
    }
  }
`;

export const REFRESH_TOKEN_MUTATION = gql`
  mutation ($refreshToken: String!) {
    refreshToken(refreshToken: $refreshToken) {
      token
      payload
      refreshToken
      refreshExpiresIn
    }
  }
`;

export const LOGOUT_MUTATION = gql`
  mutation {
    deleteTokenCookie {
      deleted
    }
    deleteRefreshTokenCookie {
      deleted
    }
  }
`;

export const REQUEST_PASSWORD_RESET_MUTATION = gql`
  mutation ($email: String!) {
    requestPasswordReset(email: $email) {
      success
      message
    }
  }
`;

export const RESET_PASSWORD_MUTATION = gql`
  mutation ($password: String!, $uid: String!, $token: String!) {
    resetPassword(password: $password, uid: $uid, token: $token) {
      success
      message
    }
  }
`;
export const ACTIVATE_MUTATION = gql`
  mutation ($uid: String!, $token: String!) {
    activateAccount(uid: $uid, token: $token) {
      success
      message
    }
  }
`;
export const SEND_VERIFICATION_EMAILS = gql`
  mutation ($users: [ID]!) {
    sendVerificationEmails(users: $users) {
      success
      message
    }
  }
`;
export const SEND_STUDENT_WELCOME_EMAILS = gql`
  mutation ($users: [ID], $school: ID) {
    sendStudentWelcomeEmail(users: $users, school: $school) {
      success
      message
    }
  }
`;

export const REQUEST_ACTIVATION_LINK_MUTATION = gql`
  mutation ($email: String!) {
    requestActivationCode(email: $email) {
      success
      message
    }
  }
`;

export const REGISTER_MUTATION = gql`
  mutation (
    $password: String!
    $firstName: String!
    $lastName: String!
    $email: String!
    $school: ID!
    $termsAndConditions: ID!
  ) {
    register(
      password: $password
      firstName: $firstName
      lastName: $lastName
      email: $email
      school: $school
      termsAndConditions: $termsAndConditions
    ) {
      success
      message
    }
  }
`;

export const START_DEMO_MUTATION = gql`
  mutation (
    $firstName: String!
    $lastName: String!
    $email: String!
    $school: ID!
    $subject: ID!
    $yearGroup: ID!
  ) {
    startDemo(
      firstName: $firstName
      lastName: $lastName
      email: $email
      school: $school
      subject: $subject
      yearGroup: $yearGroup
    ) {
      success
      message
      redirect
      redirectUrl
      tempPassword
      assignment {
        id
      }
    }
  }
`;
export const REQUEST_FREE_ACCOUNT = gql`
  mutation (
    $firstName: String!
    $lastName: String!
    $email: String!
    $dataOfficerEmail: String
    $referralCode: String
    $school: ID!
    $subject: ID!
    $yearGroups: [ID]!
  ) {
    requestFreeAccount(
      firstName: $firstName
      lastName: $lastName
      email: $email
      dataOfficerEmail: $dataOfficerEmail
      referralCode: $referralCode
      school: $school
      subject: $subject
      yearGroups: $yearGroups
    ) {
      success
      message
      supportEmail
      tempPassword
    }
  }
`;
export const REGISTER_SSO_MUTATION = gql`
  mutation (
    $token: String!
    $provider: String!
    $school: ID!
    $termsAndConditions: ID!
  ) {
    registerSso(
      token: $token
      provider: $provider
      school: $school
      termsAndConditions: $termsAndConditions
    ) {
      success
      message
    }
  }
`;

export const UPDATE_TEACHER_INFO_MUTATION = gql`
  mutation ($school: ID!, $subject: ID) {
    updateTeacherInfo(school: $school, subject: $subject) {
      success
      message
    }
  }
`;

export const DELETE_ACCOUNT_MUTATION = gql`
  mutation {
    deleteAccount {
      success
      message
    }
  }
`;

export const CHANGE_EMAIL_MUTATION = gql`
  mutation ($email: String!) {
    changeEmail(email: $email) {
      success
      message
    }
  }
`;

export const IMPERSONATE_USER_MUTATION = gql`
  mutation ($targetUser: ID!) {
    impersonateUser(targetUser: $targetUser) {
      success
      token
      refreshToken
      refreshExpiresIn
    }
  }
`;

export const CLEAR_SUBSCRIPTION_CACHE = gql`
  mutation {
    clearSubscriptionCache {
      success
      message
    }
  }
`;

export const UPDATE_USER_PREFERENCES_MUTATION = gql`
  mutation ($prefs: GenericScalar!) {
    updateUserPreferences(prefs: $prefs) {
      success
      message
    }
  }
`;

export const UNSUBSCRIBE_FROM_MARKETING_MUTATION = gql`
  mutation ($reason: String, $detail: String) {
    unsubscribeFromMarketing(reason: $reason, detail: $detail) {
      success
      message
      reason
    }
  }
`;

export const UNSUBSCRIBE_FROM_MARKETING_LINK_MUTATION = gql`
  mutation ($uid: String!, $token: String!, $reason: String, $detail: String) {
    unsubscribeFromMarketingLink(
      uid: $uid
      token: $token
      reason: $reason
      detail: $detail
    ) {
      success
      status
      message
      reason
    }
  }
`;

export const UPDATE_PROFILE_PICTURE = gql`
  mutation ($image: Upload!) {
    updateProfilePicture(image: $image) {
      success
      message
      user {
        profilePictureUrl
      }
    }
  }
`;

export const DELETE_PROFILE_PICTURE = gql`
  mutation {
    deleteProfilePicture {
      success
      message
      user {
        profilePictureUrl
      }
    }
  }
`;

export const SWITCH_ACTIVE_ROLE_ASSIGNMENT = gql`
  mutation ($roleAssignment: ID!) {
    switchActiveRoleAssignment(roleAssignment: $roleAssignment) {
      success
      message
    }
  }
`;
export const DELETE_ROLE_ASSIGNMENT = gql`
  mutation ($roleAssignment: ID!) {
    deleteRoleAssignment(roleAssignment: $roleAssignment) {
      success
      message
    }
  }
`;

export const UPDATE_ROLE_ASSIGNMENT = gql`
  mutation ($roleAssignment: ID!, $subjects: [ID], $educationLevels: [ID]) {
    updateRoleAssignment(
      roleAssignment: $roleAssignment
      subjects: $subjects
      educationLevels: $educationLevels
    ) {
      success
      message
    }
  }
`;

export const REMOVE_MEMBERSHIP = gql`
  mutation ($schoolGroupMembership: ID, $schoolMembership: ID) {
    removeMembership(
      schoolMembership: $schoolMembership
      schoolGroupMembership: $schoolGroupMembership
    ) {
      success
      message
    }
  }
`;

export const CREATE_MEMBERSHIP = gql`
  mutation (
    $user: ID!
    $schoolGroup: ID
    $school: ID
    $allowNonSchoolEmail: Boolean
  ) {
    createMembership(
      user: $user
      schoolGroup: $schoolGroup
      school: $school
      allowNonSchoolEmail: $allowNonSchoolEmail
    ) {
      success
      message
      schoolGroupMembership {
        id
        schoolGroup {
          id
          name
        }
      }
      schoolMembership {
        id
        school {
          id
          name
        }
      }
    }
  }
`;

export const CREATE_ROLE_ASSIGNMENT = gql`
  mutation ($role: ID!, $schoolGroupMembership: ID, $schoolMembership: ID) {
    createRoleAssignment(
      role: $role
      schoolGroupMembership: $schoolGroupMembership
      schoolMembership: $schoolMembership
    ) {
      success
      message

      roleAssignment {
        id
        role {
          id
          code
          name
        }
        school {
          name
        }
        schoolGroup {
          name
        }
      }
    }
  }
`;

export const UPDATE_ONBOARDING = gql`
  mutation ($purpose: SignupPurpose, $action: IntroductionAction) {
    updateOnboarding(purpose: $purpose, action: $action) {
      state {
        purpose
        eligible
        status
        version
        handledAt
      }
    }
  }
`;
